export default __webpack_public_path__ + "static/5-d1a3afd3f2b2640eb42d12c73183fe8c.jpg";